<!--
 * @Author: wenxiaopeng
 * @Date: 2023-04-11 14:47
 * @Description: 新增租户Prompt
-->
<template>
    <el-dialog title="新增租户提示词" :visible.sync="dialogVisible" custom-class="main-dialog add-dialog btn-dialog" @close="handleClose"
               append-to-body :destroy-on-close="true" :close-on-click-modal="false" width="724px">
        <div class="main-contain">
            <el-card class="basic-card">
                <el-form class="main-dialog-form" label-position="top" :rules="rules" :model="form" ref="form" @submit.native.prevent>
                    <el-form-item label="提示词" prop="title">
                        <el-input v-model.trim="form.title" placeholder="例如：英语翻译"></el-input>
                    </el-form-item>
                    <el-form-item label="提示词内容" prop="prompt">
                        <el-input type="textarea" maxlength="300" :rows="5" resize="none"
                                  show-word-limit v-model.trim="form.prompt" placeholder="例如：我需要你来充当翻译家，你的目标是把任何语言翻译成中文">
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button class="cancel" @click="handleClose">取消</el-button>
            <el-button class="confirm" type="primary" @click="handleSure" v-loading="loading"
                       :style="{ cursor: loading ? 'not-allowed' : 'pointer' }" element-loading-spinner="el-icon-loading"
                       element-loading-background="#e27373">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    data () {
        return {
            loading: false,
            dialogVisible: false,
            form: {
                tenantId: '',
                title: '',
                prompt: ''
            },
            rules: {
                title: [
                    { required: true, message: '提示词标题', trigger: 'blur' },
                    { min: 2, max: 16, message: '长度在 2 到 16 个字符', trigger: 'blur' }
                ],
                prompt: [
                    { required: true, message: '提示词内容', trigger: 'blur' },
                    { min: 2, max: 300, message: '长度在 2 到 300 个字符', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        /**
         * @author: liuc
         * @description: 显示弹窗
         * @param {} {*}
         */
        onShow (tenantId) {
            this.form.tenantId = tenantId;
            this.dialogVisible = true;
        },
        /**
         * @author: liuc
         * @description: 关闭弹窗
         * @param {*}
         */
        handleClose () {
            this.$refs.form.resetFields();
            this.dialogVisible = false;
        },
        /**
         * @author: liuc
         * @description: 确定
         * @param {*}
         */
        async handleSure () {
            let valid = await this.$refs.form.validate();
            if (valid) {
                let addResponse = await this.$api.KnowledgeCenter.addPrompt(this.form);
                if (addResponse.code == 200) {
                    this.$emit('handleInputConfirm', this.form);
                    this.handleClose();
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.basic-card {
    padding: 25px 40px;
    border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// ./src/components/KnowledgeManagement/AddPrompt.vue